import { CONVENIA } from "./convenia"
import { FAZ_CRED } from "./fazcred"
import { NEWBE } from "./newbe"
import { SOLIDES } from "./solides"
import type { Parceiro } from "./tipos"

export const PARCEIROS: Parceiro[] = [FAZ_CRED, NEWBE, SOLIDES, CONVENIA]

// A claim do token que diz por qual parceiro o link saiu. Quem assina o link do e-mail do parceiro
// grava `partner: "<slug>"`.
const CLAIM = "partner"

// Lê o payload do JWT sem conferir a assinatura, e é de propósito: aqui ele só escolhe cor e logo.
// Quem decide o que a página mostra é o authorizer, que confere a assinatura em toda chamada. Um
// token com a claim trocada à mão perde a assinatura — e cai na tela de "link vencido", pintada
// com a marca que pediu. Não abre nada.
const lerClaim = (token: string | null): string | undefined => {
    const payload = token?.split(".")[1]
    if (!payload) return undefined
    try {
        const base64 = payload.replace(/-/g, "+").replace(/_/g, "/")
        const valor = JSON.parse(atob(base64))?.[CLAIM]
        return typeof valor === "string" ? valor : undefined
    } catch {
        return undefined
    }
}

// A Faz Cred serve cada parceiro também num subdomínio próprio — newbe.fazcred.com.br, e em staging
// newbe.stg.fazcred.com.br. O primeiro rótulo do host é o slug; o resto precisa ser nosso, senão
// qualquer domínio que comece com "newbe." vestiria a marca da Newbe.
const DOMINIO_FAZ_CRED = ".fazcred.com.br"

const porSubdominio = (hostname: string, parceiros: Parceiro[]): Parceiro | undefined => {
    const host = hostname.toLowerCase()
    if (!host.endsWith(DOMINIO_FAZ_CRED)) return undefined
    const [rotulo] = host.split(".")
    return parceiros.find((parceiro) => parceiro.slug !== FAZ_CRED.slug && parceiro.slug === rotulo)
}

// Domínio primeiro, token depois, Faz Cred por último. O domínio — próprio do parceiro ou o
// subdomínio dele na Faz Cred — ganha porque é onde a pessoa está: a página de um parceiro não pode
// sair com a marca de outro por causa de um link encaminhado. A claim cobre o link aberto no domínio
// da Faz Cred. Slug desconhecido cai na Faz Cred, nunca numa tela quebrada.
export const resolverParceiro = ({
    hostname,
    token,
    parceiros = PARCEIROS,
}: { hostname: string; token: string | null; parceiros?: Parceiro[] }): Parceiro =>
    parceiros.find((parceiro) => parceiro.dominios.includes(hostname)) ??
    porSubdominio(hostname, parceiros) ??
    parceiros.find((parceiro) => parceiro.slug === lerClaim(token)) ??
    FAZ_CRED
